import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./components/global/primary.css";
import "./components/global/grid.css";
import ErrorComponent from "./components/Error Component/ErrorComponent";
import AgentScrum from "./pages/AgentScrum";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AgentScrum />} />
        <Route path="*" element={<ErrorComponent />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
